export default "__VITE_ASSET__CgEhUKsZ__"